import type { Newsletter } from 'interfaces/Account';
import SvgIcon from 'components/Globals/Base/SvgIcon';
import Link from 'components/Globals/Base/Link';
import * as S from './NewsletterHeroStyles';

export interface NewsletterHeroProps {
  className?: string;
  newsletter: Newsletter;
  onClick: (news: Newsletter) => () => void;
}

const NewsletterHero = ({ className, newsletter, onClick }: NewsletterHeroProps) => (
  <S.HeroWrapper className={className}>
    <S.ContentWrapper>
      <S.NewsletterFrequency>{newsletter.frequency}</S.NewsletterFrequency>
      <S.HeroTitle>{newsletter.title}</S.HeroTitle>
      <S.HeroDescription>
        <p>{newsletter.description}</p>
      </S.HeroDescription>
      <S.SubscribeSection hasSampleUrl={!!newsletter?.sampleUrl}>
        {newsletter?.sampleUrl ? (
          <Link
            href={newsletter.sampleUrl}
            type='tertiaryButton'
          >
            View Sample
          </Link>
        ) : null}
        <button
          type='button'
          className='sub-button'
          aria-label={newsletter.subscriptionStatus === 'subscribed' ? 'Unsubscribe' : 'Subscribe'}
          onClick={() => {
            onClick(newsletter)();
          }}
        >
          {newsletter.subscriptionStatus !== 'subscribed' ? (
            <SvgIcon name='PlusCircle' />
          ) : (
            <SvgIcon name='MinusCircle' />
          )}
        </button>
      </S.SubscribeSection>
    </S.ContentWrapper>
    {newsletter.heroImage ? (
      <S.ImageWrapper
        src={newsletter.heroImage}
        alt='newsletter image'
      />
    ) : null}
  </S.HeroWrapper>
);

export default NewsletterHero;
